export default __webpack_public_path__ + "static/media/serveless.f225977b.svg";